/* eslint-disable default-case */
import React, { useState } from 'react'
import GenericTableComponent from '../../../genericComponents/tableComponent/GenericTableComponent'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom'
import DetailApiLog from './DetailApiLog';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import ParentModal from '../../../genericComponents/ParentModal';
import { dispatchHandler } from '../../../helper/apiHelperFunctions';
import { getPermissionKey } from '../../../helper/permissions';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { CONFIG } from '../../../config';

const AdministrationAPILogs = (props) => {
	const location = useLocation();
	const dispatch = useDispatch()
	const urlSearchParams = new URLSearchParams(location.search),
		params = Object.fromEntries(urlSearchParams.entries());

	const administrationStore = useSelector(state => state.administrationStore);
	const generalStore = useSelector((state) => state.generalStore)

	const [currentTab, setCurrentTab] = useState(params.apiType ? JSON.parse(decodeURIComponent(params.apiType)) : "INBOUND");
	const [selectedModal, setSelectedModal] = useState("");
	const [selectedData, setSelectedData] = useState({});

	const tableHeadersMap = {
		INBOUND: {
			main: {
				name: "Main",
				key: "ADM_API_LOG_HISTORY"
			}
		},
		OUTBOUND: {
			main: {
				name: "Main",
				key: "ADM_API_LOG_HISTORY"
			}
		}
	}

	const handleChange = (type, data) => {
		switch (type) {
			case 'detailApiModal':
				setSelectedModal('detailApiModal')
				setSelectedData(data);
				break

			case 'retryApiCall':
				let payload = {
					"apiType": "INBOUND",
					"ids": data
				}
				dispatchHandler(dispatch, 'getApiLogRetryRequest', payload, getPermissionKey("administration", "apilogs", "view"))
				break
			default: break
		}
	}

	const getParentChildProps = () => {
		let payload = {
			closeModal: () => { setSelectedModal("") },
			// postitionProps: { top: '50%', left: '50%',transform: 'translate(-50%, -50%)'},
			parentModalOuterMostClassName: 'flex items-center justify-center',
			postitionProps: { position: 'relative' },
			dimensions: { width: "60vw", height: "90vh", maxHeight: '740px', maxWidth: '870px' },
			animationType: "bottom",
		}
		switch (selectedModal) {
			case 'detailApiModal':
				return {
					...payload,
					selectedData: selectedData
				}
			default:
				break;
		}
	}

	const getChildComponent = () => {
		switch (selectedModal) {
			case 'detailApiModal': return DetailApiLog
			default: {
				return <React.Fragment />
			}
		}
	}

	const changeTab = (tab) => () => {
		setCurrentTab(tab);
	}

	const renderRHSExtras = (selectedItems) => {
		return (
			<React.Fragment>
				{/* <GenericCustomButton
					type="primary"
					onClick={() => handleChange("apiAccessDetails")}
					label="API Access Details"
				/> */}
				<GenericCustomButton
					sendEventAnalyticsToGoogle = { true }
					type="default"
					disabled={currentTab === 'OUTBOUND' || Object.keys(selectedItems || {})?.length === 0}
					onClick={() => handleChange("retryApiCall", Object.keys(selectedItems))}
					label="Retry"
				/>
			</React.Fragment>
		)
	}

	const renderSummary = () => {
		const summaryData = generalStore?.getTableComponentSummaryData?.data?.resource?.tableLabelData || {}
		const summaryLabelData = generalStore?.getTableComponentSummaryData?.data?.resource?.summaryLabelData || [];
	
		return (
			<div className="api-summary-head">
				<ul className="ash-inner">
					<li className="ash-history">
						<LanguageTranslator tag="label"><LanguageTranslator>Total API Calls</LanguageTranslator>
							<span className="ash-info">
								<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
									<path id="iconmonstr-info-2" fill="#97abbf" d="M7 1.167A5.833 5.833 0 1 1 1.167 7 5.84 5.84 0 0 1 7 1.167zM7 0a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm.583 10.5H6.417V5.833h1.166zM7 3.354a.729.729 0 1 1-.729.729A.729.729 0 0 1 7 3.354z" />
								</svg>
								<div className="ash-information">
									<table className="table">
										<thead>
											<tr>
												<th><LanguageTranslator tag="label">API Name</LanguageTranslator></th>
												<th><LanguageTranslator tag="label">Success</LanguageTranslator></th>
												<th><LanguageTranslator tag="label">Failure</LanguageTranslator></th>
												<th><LanguageTranslator tag="label">% Success Rate</LanguageTranslator></th>
												<th><LanguageTranslator tag="label">Total Api Calls</LanguageTranslator></th>
											</tr>
										</thead>
										<tbody>
											{
												summaryLabelData.map((item, key) => (
													<tr key={key}>
														<td><label className="bold">{item?.api_name}</label></td>
														<td align="right"><label className="asht-success">{item?.success_calls}</label></td>
														<td align="right"><label className="asht-fail">{item?.failure_calls}</label></td>
														<td align="right"><label>{item?.percentage_success}</label></td>
														<td align="right"><label>{item?.total_api_calls}</label></td>
													</tr>
												))
											}
										</tbody>
									</table>
								</div>
							</span>
						</LanguageTranslator>
						<span>{summaryData?.total_api_calls}</span>
					</li>
					<li className="ash-history ash-borderlft">
						<LanguageTranslator tag="label">Success Calls</LanguageTranslator>
						<span>{summaryData?.success_calls}</span>
					</li>
					<li className="ash-history ash-borderlft">
						<LanguageTranslator tag="label">Failure Calls</LanguageTranslator>
						<span>{summaryData?.failure_calls}</span>
					</li>
					<li className="ash-history ash-borderlft">
						<LanguageTranslator tag="label">% Success Rate</LanguageTranslator>
						<span>{summaryData?.percentage_success}</span>
					</li>
				</ul>
			</div>
		)
	}

	return (
		<React.Fragment>
			<GenericTableComponent
				currentTab = {currentTab}
				actionBarConfig={{
					tabs: {
						key: "apiType",
						data: {
							INBOUND: 'Inbound',
							OUTBOUND: "Outbound",
						},
						onChange: changeTab
					},
					emailReport: false,
					downloadReport: {
						headerLevelModule: tableHeadersMap[currentTab]?.main?.key,
						tableHeadersMap: tableHeadersMap?.[currentTab]
					},
					rhsExtras: renderRHSExtras,
					isSummaryApiRequire: true,
				}}
				tableConfig={{
					select: {
						disabled: false
					},
					customCols: {
						apiName: item => <label style={{ cursor: 'pointer' }} className="!font-semibold textMaroon whiteUnset wordBreakInherit" data-interactive="true" onClick={() => handleChange('detailApiModal', item)}>{item.apiName}</label>,
					},
					summary: !generalStore?.getTableComponentSummaryData?.data?.resource?.tableLabelData? [] :
						{
							render: renderSummary
						},
					columnSetting: {
						disabled: generalStore?.getHeadersData?.isLoading || generalStore?.createHeadersData?.isLoading
					},
				}
				}
				tableHeadersPayload={tableHeadersMap?.[currentTab] || {}}
				tableHeadersMap={tableHeadersMap}
				// quickFiltersPayload={{
				// 	attributeType: tableHeadersMap[currentTab].main.key,
				// 	displayName: tableHeadersMap[currentTab].main.key,
				// 	filterName: ""
				// }}
				tableDataPayload={{
					type: 1,
					pageNo: 1,
					sortedBy: "",
					sortedIn: "",
					filter: {},
					status: '',
					search: '',
					apiType: currentTab,
					pageSize: 10,
					apiUrl : "/admin/master/integration/api/log",
					summaryApiUrl: "/admin/master/integration/api/summary",
					baseUrl : CONFIG.SM_BACKEND_BASE_URL,
					isChangeSummaryBaseUrl : true,
				}}
				tableComExtraHeaders={getPermissionKey("administration", "apilogs", "view")}
				tableSummaryHeaders = {getPermissionKey("administration", "apilogs", "view")}
				getTableDataLoading={generalStore?.getTableComponentListData?.isLoading}
				getTableDataSuccess={generalStore?.getTableComponentListData?.isSuccess}
				getTableDataError={generalStore?.getTableComponentListData?.isError}
				tableData={
					{
						data: generalStore?.getTableComponentListData?.data?.resource || [],
						totalItems: generalStore?.getTableComponentListData?.data?.totalRecord || 0,
						currentPage: generalStore?.getTableComponentListData?.data?.currPage || 1,
						maxPage: generalStore?.getTableComponentListData?.data?.maxPage || 1,
						getTableApiData: generalStore?.getTableComponentListData?.data || []
					}
				}
				setCurrentTab = {setCurrentTab}
				availableStores={["generalStore", "administrationStore"]}
				{...props}
			/>
			{selectedModal && <ParentModal
				getParentChildProps={getParentChildProps()}
				childComponent={getChildComponent()}
				closeModal={() => { setSelectedModal(false) }}
			/>}
		</React.Fragment>
	)
}

export default AdministrationAPILogs